import React from "react"
import styled from "styled-components"
import { TimelineMax, Power0 } from "gsap"
import PropTypes from "prop-types"
import Slider from "@mui/material/Slider"
import { makeStyles } from "tss-react/mui"

import Caption from "../../components/caption"

import teaser from "./photon_banner.png"
import scene from "./SVG/photon_background.svg"
import einstein from "./SVG/photon_einstein.svg"
import einsteinBlink from "./SVG/photon_einstein_blink.svg"
import bulb from "./SVG/photon_bulb.svg"
import bulbLit from "./SVG/photon_bulb_lit.svg"

const meta = {
    title: "PhotonBanner",
    creator: "Shivani Mattikalli and Chris Cesare",
    type: "InteractiveGraphics",
    caption:
        "In 1905, Einstein had an idea: maybe light travels in discrete bunches of energy.",
    published: true,
    teaserImage: teaser,
    keywords: ["photons", "photoelectric effect", "interactive"],
}

const SceneWrapper = styled.div``

const UnstyledPhoton = ({ className, number, top, left }) => {
    let params = "absolute photon" + number + " " + className
    return (
        <svg
            className={params}
            style={{
                position: "absolute",
                opacity: 0,
                top: top,
                left: left,
                width: "2%",
            }}
        >
            <path
                className="cls-1"
                d="M2.72,6.63,2.87,7c.06.14.11.28.17.41l.09.21a.88.88,0,0,1,.05.15v0L3.28,8a.63.63,0,0,1,.07.12l.06.08a1.37,1.37,0,0,0,.13.2h0l0,0h0a.75.75,0,0,0,.09.15l.12.16,0,0a.43.43,0,0,1,0-.07L4,8.56l.1-.12h0a.06.06,0,0,0,0,0v0l0,0,0,0h0l.09-.11h0l0,0L4.37,8l.14-.21.18-.22.06-.06v0l-2-.93v0Z"
            />
            <path
                className="cls-1"
                d="M4.86,7.59l-.09.14L4.63,8h0l.09-.14,0-.07.1-.16h0v0Z"
            />
            <path className="cls-1" d="M4,10.32H4a.19.19,0,0,0,0-.07l0,.07Z" />
            <polygon
                className="cls-1"
                points="4.38 10.49 4.38 10.49 4.38 10.49 4.38 10.49 4.38 10.49 4.38 10.49 4.38 10.49"
            />
            <path className="cls-1" d="M4.09,8.35h0Z" />
            <path
                className="cls-1"
                d="M5.43,8c0,.09-.1.18-.16.27a.22.22,0,0,1,0,.08h0l0,0,0,.14c-.08.21-.16.43-.25.65l-.24.64,0,.12v0c0,.07,0,.13-.05.19l0,.17,0,.06s0,.07,0,.1v0L16.1,15.81v0l0,0,0,0,0,0,0-.05.1-.12.06-.07h0l0,0,0,0,.07-.09v0l.07-.11a1.74,1.74,0,0,0,.11-.18,1.62,1.62,0,0,0,.1-.18s0,0,0-.08l0,0,0,0h0c0-.05.05-.1.08-.14l.1-.18.09-.19c0-.08.07-.15.1-.22a.3.3,0,0,1,0-.1s0,0,0-.05,0,0,0,0l.09-.23,0-.11,0,0a0,0,0,0,1,0,0v-.05a.06.06,0,0,1,0,0v0h0l-12-5.42L5.43,8Z"
            />
            <path className="cls-1" d="M17.55,13.36v0h0v0Z" />
            <path
                className="cls-1"
                d="M17.94,13.57a.3.3,0,0,0,0,.1l0,.05v0c0,.11-.08.23-.13.34s-.2.43-.29.65h0v0l0,0h0l0,0,0,.06s0,0,0,.06v0h0a0,0,0,0,1,0,.05,1.57,1.57,0,0,1-.09.23v0s0,0,0,.06l0,.13a.65.65,0,0,0,0,.13,2.76,2.76,0,0,1-.08.27c0,.08-.05.15-.07.23s0,0,0,.06v0h0l1.12.51a.53.53,0,0,1,.32-.12l.25,0,.53-.05.7-.11.69-.13h.05l.23-.07V16a1.7,1.7,0,0,1,0-.22.78.78,0,0,1,0-.16v0l-.15-.31c0-.11-.1-.22-.16-.33l-.12-.27a.14.14,0,0,1,0-.06L18,13.51s0,0,0,.06Z"
            />
            <polygon
                className="cls-1"
                points="17.45 14.74 17.45 14.74 17.45 14.73 17.45 14.74 17.45 14.74 17.45 14.74"
            />
            <path className="cls-1" d="M16.55,16l0,0h0v0Z" />
            <path className="cls-1" d="M16.78,16.08v0h0l0-.08,0,0Z" />
            <path className="cls-1" d="M20.48,17.79l0,0v0Z" />
            <path
                className="cls-2"
                d="M4.6,11.47A6.44,6.44,0,0,0,11,17.85,6.38,6.38,0,0,0,11,5.09,6.44,6.44,0,0,0,4.6,11.47Z"
            />
            <path
                className="cls-2"
                d="M18.41,12.49a2.62,2.62,0,0,0-.31.6l-.14.33a0,0,0,0,1,0,0,.11.11,0,0,0,0,.05l0,.07,0,.1,0,.05v0c0,.11-.08.23-.13.34s-.21.43-.3.66v0l0,0h0l0,0,0,.06s0,0,0,.06v0h0a0,0,0,0,1,0,.05,1.57,1.57,0,0,1-.09.23v0s0,0,0,.06l0,.13a.65.65,0,0,0,0,.13c0,.09-.05.18-.08.27l0,.09a.49.49,0,0,0,.14.32.56.56,0,0,0,.23.12.49.49,0,0,0,.21,0,.34.34,0,0,0,.06.12.56.56,0,0,0,.36.23.49.49,0,0,1,.38-.18l.25,0,.53-.05.7-.11.69-.13h.05l.23-.07h0c0-.07,0-.14,0-.2a1.7,1.7,0,0,1,0-.22v-.08a.66.66,0,0,0-.09-.19l-.15-.29c-.25-.47-.47-.94-.68-1.42h0c-.14-.35-.27-.69-.44-1a.89.89,0,0,0-.36-.43.52.52,0,0,0-.27-.07.6.6,0,0,0-.47.22Zm.46,1h0a.08.08,0,0,0,0,0l0,.07,0,0Zm1.05,2.3-.06-.19h0l.13.23h-.06a.07.07,0,0,0,0-.05Z"
            />
            <polygon
                className="cls-2"
                points="19.96 13.8 19.96 13.8 19.96 13.8 19.96 13.8 19.96 13.8"
            />
            <path className="cls-2" d="M20,13.81h0Z" />
            <path
                className="cls-2"
                d="M20,6.32l-.44,0c-.21,0-.43.07-.64.12-.37.07-.74.16-1.11.21h-.09l-.2,0a.77.77,0,0,0-.19.08.5.5,0,0,0-.22.29.57.57,0,0,0,0,.29,1.21,1.21,0,0,0,.11.3l.1.22c.15.3.3.6.43.91v0c0,.11.09.22.13.34l0,.07a.14.14,0,0,1,0,.06.65.65,0,0,0,.13.23l0,0h0c.06.16.12.36.3.43a.44.44,0,0,0,.32,0h0a.53.53,0,0,0,.27.08.6.6,0,0,0,.42-.23,7.64,7.64,0,0,0,.75-1.13,6.36,6.36,0,0,0,.3-.58c.08-.16.15-.33.22-.5a2.27,2.27,0,0,0,.12-.5,1,1,0,0,0,0-.17.7.7,0,0,0-.09-.32.65.65,0,0,0-.36-.29,1.27,1.27,0,0,0-.34,0ZM20,7h0Zm0,.19a1.42,1.42,0,0,1-.07.22.08.08,0,0,0,0,0,.51.51,0,0,0-.09-.16h.17Zm-2,.06h0Zm.88.14a1.3,1.3,0,0,0-.42.25.35.35,0,0,0-.12-.15l.54-.1Zm.44,1.09.16-.16c-.1.17-.19.33-.3.49l0-.11,0,0a1,1,0,0,0,.19-.17Z"
            />
            <path
                className="cls-2"
                d="M16.43,1.78a4.32,4.32,0,0,0-.68.26c-.41.17-.82.35-1.22.54a3.68,3.68,0,0,0-.44.23,1.19,1.19,0,0,0-.38.33.6.6,0,0,0-.05.62.46.46,0,0,0,.13.18,1.18,1.18,0,0,0,.18.13l.14.1.47.4.29.26a1.55,1.55,0,0,0,.52.37.42.42,0,0,0,.31,0,.69.69,0,0,0,.13.11.52.52,0,0,0,.55,0,1,1,0,0,0,.33-.58l.09-.32a11.52,11.52,0,0,0,.31-1.32,3,3,0,0,0,.06-.67,2.17,2.17,0,0,0,0-.25A.53.53,0,0,0,17,1.94a.52.52,0,0,0-.41-.17Zm-.12.94v.07c0,.23-.08.45-.13.68a.42.42,0,0,0-.11-.18,1.22,1.22,0,0,0-.17-.15.76.76,0,0,0-.33-.08h0l.67-.29.11,0Z"
            />
            <path
                className="cls-2"
                d="M15.65,3.28a.44.44,0,0,0,.43.43.43.43,0,0,0,.42-.43.42.42,0,0,0-.42-.42.43.43,0,0,0-.43.42Z"
            />
            <path
                className="cls-2"
                d="M10.64,2.89a2.68,2.68,0,0,1-.56.13c-.49.06-1,.12-1.45.2a.4.4,0,0,0-.25.19.43.43,0,0,0-.05.33.39.39,0,0,0,.2.25.43.43,0,0,0,.33,0l.65-.1.61-.08a4,4,0,0,0,.75-.14.49.49,0,0,0,.25-.2.42.42,0,0,0,0-.33.45.45,0,0,0-.41-.32l-.11,0Z"
            />
            <path
                className="cls-2"
                d="M9.23.16H9.16A.38.38,0,0,0,9,.22a.59.59,0,0,0-.18.13.71.71,0,0,0-.16.26C8.55.74,8.5.87,8.45,1s-.13.42-.19.63A11.06,11.06,0,0,0,8,2.92l-.09.56v.11A.37.37,0,0,0,8,3.8a.41.41,0,0,0,.25.2.47.47,0,0,0,.33,0,.42.42,0,0,0,.19-.26l.12-.77A.49.49,0,0,0,9,3.16a.41.41,0,0,0,.3.12l.13,0a3.17,3.17,0,0,0,.41.12.42.42,0,0,0,.52-.3.44.44,0,0,0,0-.2l.09.12c.16.2.38.47.68.36a.44.44,0,0,0,.25-.2.42.42,0,0,0,0-.33A4,4,0,0,0,11,2.12c-.11-.18-.22-.37-.34-.55s-.28-.41-.43-.61A3.61,3.61,0,0,0,10,.66,1.62,1.62,0,0,0,9.69.35.86.86,0,0,0,9.24.16Zm.07,1a2.61,2.61,0,0,1,.27.3l0,0a.75.75,0,0,0-.14.17l0,.05a.58.58,0,0,0-.32,0q.08-.28.18-.57Z"
            />
            <path
                className="cls-2"
                d="M5.43,5.3a.5.5,0,0,0-.25.2c-.13.16-.28.31-.42.46s-.3.35-.44.53a7.78,7.78,0,0,0-.68,1.19.42.42,0,0,0,.15.58.46.46,0,0,0,.38,0l.07-.08h0l0,0L4.37,8l.14-.21h0l.2-.37a6.49,6.49,0,0,1,.36-.55c.27-.33.57-.62.83-1A.42.42,0,0,0,6,5.6a.41.41,0,0,0-.19-.25.43.43,0,0,0-.22-.06Z"
            />
            <path
                className="cls-2"
                d="M2.66,4.23a.59.59,0,0,0-.14.06.52.52,0,0,0-.19.17.87.87,0,0,0-.07.17.65.65,0,0,0,0,.2v0a1.16,1.16,0,0,1,0,.18l.15.64c0,.11,0,.22.08.33s.07.21.1.31h0v0h0s0,0,0,.07a1.07,1.07,0,0,1,.07.19L2.87,7c.06.14.11.28.17.41s0,.12.07.17l.18.23A1,1,0,0,0,3.42,8a.39.39,0,0,0,.3.12.41.41,0,0,0,.42-.42A.45.45,0,0,0,4,7.41c-.06-.07-.11-.15-.17-.21L3.71,7h.07a.41.41,0,0,0,.3-.12l.1-.12s0,0,0-.06l.1-.07a.36.36,0,0,0,.13-.29l.2-.09.76-.38.11-.05a.42.42,0,0,0,.16-.58A.49.49,0,0,0,5.36,5L5.23,5l-.3-.09a6.5,6.5,0,0,1-.62-.22L3.7,4.42,3.37,4.3l-.29-.07-.25,0-.17,0Zm.48.89.34.12a.44.44,0,0,0-.15,0,.53.53,0,0,0-.13.13l-.06-.3ZM4,5.47l0,0,.15.06.06,0h0A.38.38,0,0,0,4,5.47Zm-.57.72v0Z"
            />
            <path
                className="cls-2"
                d="M3.25,5.1a.4.4,0,0,0-.19.25C3,5.58,3,5.81,3,6a2.44,2.44,0,0,0,0,.27.71.71,0,0,0,0,.14.91.91,0,0,0,0,.33.45.45,0,0,0,.2.25.4.4,0,0,0,.32,0,.47.47,0,0,0,.26-.2.42.42,0,0,0,0-.33s0,0,0,0a4.05,4.05,0,0,1,0-.92.47.47,0,0,0,0-.33.46.46,0,0,0-.26-.19L3.47,5a.43.43,0,0,0-.22.06Zm.59,1.35v0Z"
            />
            <path
                className="cls-2"
                d="M2.87,11.05a.63.63,0,0,0-.24.14l-.1.09-.3.24-.47.32-.53.26a3.25,3.25,0,0,1-.4.15c-.31.09-.72.15-.81.51s.17.56.39.72l.36.25.42.27.91.56.44.25.23.14a1.23,1.23,0,0,0,.32.17.39.39,0,0,0,.26,0,.41.41,0,0,0,.41.1.44.44,0,0,0,.19-.1.52.52,0,0,0,.11-.19c.07-.18-.06-.36-.13-.51h0a.43.43,0,0,0,.25-.5c-.1-.32-.2-.63-.28-1s-.13-.58-.17-.87a1.39,1.39,0,0,0-.43-1A.55.55,0,0,0,3,11Zm.33.78h0Zm-.53.43.2-.16a1.7,1.7,0,0,1,0,.22h0l-.08,0a.4.4,0,0,0-.15,0h0ZM1.35,13l.06,0a.69.69,0,0,0-.11.13L1.22,13l.13,0Z"
            />
            <path
                className="cls-2"
                d="M5.22,16.85a.43.43,0,0,0-.13.3.42.42,0,0,0,.13.3,9.58,9.58,0,0,0,1.16.85l.57.33c.17.1.35.19.52.3a.43.43,0,0,0,.6,0,.43.43,0,0,0,0-.6A2.62,2.62,0,0,0,7.53,18L7,17.68a8.57,8.57,0,0,1-.89-.59l-.3-.24a.47.47,0,0,0-.3-.12.42.42,0,0,0-.3.12Z"
            />
            <path
                className="cls-2"
                d="M5.16,17.41c-.07.24-.15.48-.21.72s-.09.44-.13.67-.07.47-.11.71l0,.3a1.07,1.07,0,0,0,0,.25.66.66,0,0,0,.07.25.73.73,0,0,0,.22.21.89.89,0,0,0,.45.09,1.94,1.94,0,0,0,.49-.11,3.67,3.67,0,0,0,.73-.32,3.91,3.91,0,0,0,.6-.4,2.43,2.43,0,0,0,.3-.26.71.71,0,0,0,.12-.18.64.64,0,0,0,.07-.27.51.51,0,0,0-.09-.27.77.77,0,0,0-.23-.21,2.18,2.18,0,0,0-.83-.22,3.2,3.2,0,0,1-.42-.1v0a.45.45,0,0,0-.12-.2.4.4,0,0,0-.15-.1l.1-.31a.43.43,0,0,0-.3-.52l-.11,0a.43.43,0,0,0-.41.31Zm.89.79,0,0s0,0,0,0Z"
            />
            <path
                className="cls-2"
                d="M12.59,18.79a10.67,10.67,0,0,1-1.25.26,4.21,4.21,0,0,1-.5,0c-.21,0-.43,0-.64,0a.44.44,0,0,0-.43.43.43.43,0,0,0,.13.3.42.42,0,0,0,.3.13,4.85,4.85,0,0,0,.66,0c.24,0,.47,0,.71-.07a10.67,10.67,0,0,0,1.25-.26.42.42,0,0,0-.12-.83Z"
            />
            <path
                className="cls-2"
                d="M11.71,19.15a.68.68,0,0,0-.2.07.59.59,0,0,0-.18.13,1,1,0,0,0-.22.34s0,0,0,.06h-.18l-.12,0h-.08l0-.2a.39.39,0,0,0-.19-.26.42.42,0,0,0-.33,0,.43.43,0,0,0-.26.2.44.44,0,0,0,0,.32,5.11,5.11,0,0,0,.2.86,4.08,4.08,0,0,0,.35.73c.11.19.24.38.37.57a6.22,6.22,0,0,0,.46.56,2.28,2.28,0,0,0,.22.22.72.72,0,0,0,.38.21.49.49,0,0,0,.27,0,1,1,0,0,0,.27-.17,1.24,1.24,0,0,0,.14-.18,1.62,1.62,0,0,0,.1-.18l.11-.26c0-.11.08-.22.13-.34l.21-.6.21-.61.09-.27s0-.07,0-.11a.61.61,0,0,0,0-.27.86.86,0,0,0-.13-.23.89.89,0,0,0-.24-.18l-.22-.11-.33-.13a1.2,1.2,0,0,0-.37-.1.82.82,0,0,0-.22,0,.5.5,0,0,0-.17,0Zm.8,1h0l-.09.27-.15.44c0-.05,0-.1,0-.15s.09-.35.14-.53l.06,0Zm-.73,1.56a.47.47,0,0,0,.25-.19c0,.12-.09.24-.14.36h0a1.29,1.29,0,0,1-.16-.17Z"
            />
            <path
                className="cls-3"
                d="M13.7,3.51a.18.18,0,0,0-.1.07.19.19,0,0,0,0,.13.23.23,0,0,0,.08.09l.09.07,0,0,1,.81.48.41.24.2.14.11.07.06.08,0h.09A.15.15,0,0,0,16,5.33a.14.14,0,0,0-.15-.15l-.08-.06-.41-.35-.5-.41c-.34-.29-.69-.56-1-.83a.11.11,0,0,0-.08,0Z"
            />
            <path
                className="cls-3"
                d="M16.69,1.56l-.16,0a2.37,2.37,0,0,0-.34.13,2.26,2.26,0,0,0-.26.16l-.29.19-.59.36c-.2.11-.4.22-.59.34a3.94,3.94,0,0,0-.48.31l-.15.11-.1.09-.22.22a.17.17,0,0,0,0,.23.16.16,0,0,0,.22,0L14,3.5a1.84,1.84,0,0,1,.22-.17,2.2,2.2,0,0,1,.25-.17l.3-.18.58-.33a6.1,6.1,0,0,0,.54-.34l.28-.18.14-.08L16.42,2a1.76,1.76,0,0,1,.3-.1,1.08,1.08,0,0,1,0,.31v0c0,.2-.08.39-.12.58l-.09.33c0,.22-.11.44-.17.66s-.1.43-.14.65-.08.47-.1.7a.88.88,0,0,1,0,.16.18.18,0,0,0,.05.12.15.15,0,0,0,.11,0,.16.16,0,0,0,.12,0,.17.17,0,0,0,0-.12c0-.1,0-.21,0-.32s.07-.44.11-.66L16.59,4l.09-.34c.06-.23.12-.45.17-.68l.09-.34c0-.15.06-.31.08-.47a1.19,1.19,0,0,0,0-.46.2.2,0,0,0,0-.08.23.23,0,0,0-.07-.07.18.18,0,0,0-.1,0Zm0,.64Z"
            />
            <path
                className="cls-3"
                d="M19.09,12.11a.31.31,0,0,0-.14.07l-.05.06a2.73,2.73,0,0,0-.21.3c-.12.21-.22.42-.32.63l-.3.62c-.16.33-.33.65-.49,1-.08.18-.17.36-.26.54l-.11.26-.06.17c0,.06,0,.11,0,.16v0a2.35,2.35,0,0,0-.05.37.16.16,0,0,0,.16.16.16.16,0,0,0,.11-.05.14.14,0,0,0,.05-.11.88.88,0,0,1,0-.16,2.11,2.11,0,0,1,.12-.43c.08-.2.17-.39.26-.57s.2-.42.31-.63l.63-1.28a4.68,4.68,0,0,1,.4-.73,1.89,1.89,0,0,1,.11.25l.15.34c.09.21.19.43.29.63L20.22,15a3.77,3.77,0,0,0,.41.7.18.18,0,0,0,.23,0l0-.05-.15-.3L20.59,15a1.24,1.24,0,0,1-.1-.2l-.24-.52L20,13.63l-.3-.64c-.09-.22-.19-.44-.28-.65a.86.86,0,0,0-.1-.16.18.18,0,0,0-.09-.06l-.06,0Zm-1.6,3.61h0Zm-.11.38v0Z"
            />
            <path
                className="cls-3"
                d="M20.61,15.75l-.06,0a2.45,2.45,0,0,1-.37.08c-.21,0-.43,0-.64.06l-.37.05L19,16l-.19,0c-.44.11-.87.27-1.3.41l-.27.09a.16.16,0,0,0,.09.31l1.06-.35.48-.15.25-.06a.7.7,0,0,1,.14,0l.15,0c.11,0,.21,0,.32,0l.35,0,.37-.06.15,0,.16-.07a.16.16,0,0,0,.07-.09.13.13,0,0,0,0-.12.14.14,0,0,0-.09-.08h0l-.08,0Zm-1.2.5h0Z"
            />
            <path
                className="cls-3"
                d="M17.17,7.14a.14.14,0,0,0-.11.15,3.15,3.15,0,0,0,.09.42.15.15,0,0,0,.15.11c0,.07.07.13.1.19l.31.59c.11.22.21.44.31.66l.27.59a1.62,1.62,0,0,0,.19.37.14.14,0,0,0,.21.06.15.15,0,0,0,.06-.22,2.64,2.64,0,0,1-.15-.29c0-.1-.09-.2-.14-.3l-.27-.62-.33-.65-.31-.59-.09-.18a2.14,2.14,0,0,0-.1-.22.17.17,0,0,0-.14-.08Z"
            />
            <path
                className="cls-3"
                d="M20.13,6.88l-.64.06H17.74l-.2,0-.19,0L17.2,7l-.19,0a.17.17,0,0,0-.12.2.17.17,0,0,0,.2.11l.29-.07.23,0h0l.33,0h1.39l.36,0c.22,0,.44,0,.65-.07h.09A.16.16,0,0,0,20.57,7a.16.16,0,0,0-.16-.16h0a1.09,1.09,0,0,0-.26,0Zm0,0h0Z"
            />
            <path
                className="cls-3"
                d="M20.21,7.24c-.1,0-.16.11-.22.19l-.08.13c-.06.08-.11.17-.17.26s-.25.39-.37.58l-.18.3A2,2,0,0,0,19,9a.75.75,0,0,0-.07.12c0,.06-.05.12-.07.17l-.14.36-.12.37a.16.16,0,0,0,.11.2.17.17,0,0,0,.2-.11c0-.14.09-.27.13-.41s.09-.23.14-.34l.09-.2c0-.08.08-.16.13-.24s.2-.33.31-.49L20,8c.09-.14.17-.28.26-.41l0,0a.17.17,0,0,0,.1-.19.17.17,0,0,0-.16-.12Z"
            />
            <path
                className="cls-3"
                d="M13,18.92l-.18,0h.05l-.34,0h-.34c-.23,0-.45.05-.68.09l-.7.13-.66.13-.13,0-.17,0a.16.16,0,0,0-.11.16.16.16,0,0,0,.16.15,2.3,2.3,0,0,0,.26,0,.15.15,0,0,0,.11,0l.1,0,.41-.08.83-.16c.25,0,.5-.06.76-.08l.39,0a1.91,1.91,0,0,0,.33-.06,1.51,1.51,0,0,1,0,.3v0c0,.24-.07.48-.12.71s-.11.47-.17.7-.11.43-.15.65-.08.45-.11.67a1.49,1.49,0,0,1,0,.21h0a.16.16,0,0,0,.07.21.15.15,0,0,0,.21-.06.6.6,0,0,0,.06-.23,1.1,1.1,0,0,1,0-.18c0-.1,0-.2,0-.31s.09-.45.14-.67l.18-.72c0-.11.05-.23.08-.34s0-.09,0-.14l0-.16,0-.24a1.64,1.64,0,0,0,0-.23.67.67,0,0,0,0-.28l0-.09a.32.32,0,0,0-.12-.08h-.07l-.15,0Zm.09.3v0Z"
            />
            <path
                className="cls-3"
                d="M9.7,19.74a.16.16,0,0,0-.11.05.17.17,0,0,0,0,.12.37.37,0,0,0,0,.14.54.54,0,0,0,.05.11.13.13,0,0,0,.07.09.17.17,0,0,0,.12,0l.05,0,0,0,.15.16.2.22c.17.18.34.35.5.53l.47.49.44.51.2.21.23.18a1.81,1.81,0,0,1,.21.18.33.33,0,0,0,.16.11.21.21,0,0,0,.24-.11.16.16,0,0,0,0-.11.16.16,0,0,0,0-.11.21.21,0,0,0-.12-.05l-.07,0,0,0-.13-.09-.24-.19c-.16-.15-.3-.32-.44-.48-.3-.35-.62-.68-.94-1l-.38-.4-.2-.21L10,19.93l-.14-.12-.08,0-.1,0Z"
            />
            <path
                className="cls-3"
                d="M9.27,0a.27.27,0,0,0-.19.08A.83.83,0,0,0,8.94.3a1.55,1.55,0,0,0-.08.23L8.8.69c0,.1-.07.21-.1.32l-.21.72c-.09.31-.15.63-.21,1a7.48,7.48,0,0,0-.13.95,2.25,2.25,0,0,1-.05.22.16.16,0,1,0,.23.21A.26.26,0,0,0,8.4,4c.24,0,.49,0,.73-.08l.4-.07.35-.07c.45-.1.89-.25,1.33-.37a3.41,3.41,0,0,1,.46-.1h0l.13,0A.21.21,0,0,0,12,3.1.16.16,0,0,0,12,3a.33.33,0,0,0,0-.13,2.05,2.05,0,0,0-.39-.49l-.25-.23-.24-.23a8.53,8.53,0,0,1-.93-1l0,0h0L9.72.4A2.39,2.39,0,0,0,9.51.14.37.37,0,0,0,9.28,0Zm0,.3h0Zm0,0Zm0,0,.06.06c.13.16.24.33.37.49s.29.36.44.53a3.45,3.45,0,0,0,.26.28c.07.08.15.15.23.23l.48.45a4.78,4.78,0,0,1,.45.45.76.76,0,0,1,.08.11l-.22,0-.29.07-.66.19-.6.17-.32.07-.3,0-.38.06-.4,0s0-.1,0-.16c0-.22.06-.45.1-.68l.06-.31c0-.11,0-.22.07-.33L8.8,1.8c0-.12.07-.25.11-.37S9,1,9.11.76L9.2.51c0-.06.05-.11.07-.16ZM8.48,3.44v0Zm.81.1h0Zm-1.18.28v0h0v0Z"
            />
            <path
                className="cls-3"
                d="M2.31,4.66l-.09,0a1,1,0,0,1,0,.16,1.16,1.16,0,0,1,0,.18l.15.64c0,.11,0,.22.08.33a2.81,2.81,0,0,0,.1.31h0v0h0s0,0,0,.07a1.07,1.07,0,0,1,.07.19L2.87,7c.06.14.11.28.17.41l.09.21a.88.88,0,0,1,.05.15v0L3.28,8l.07.12.06.09a.43.43,0,0,0,0,.07.15.15,0,0,0,.16,0A.16.16,0,0,0,3.66,8a6.24,6.24,0,0,1-.35-.68c-.07-.17-.15-.34-.21-.51S3,6.43,2.88,6.23L2.7,5.72c0-.1-.06-.2-.1-.3S2.51,5.14,2.48,5H3.57l.38,0c.23,0,.45.06.68.11a5.7,5.7,0,0,1,.81.22l.2.1,0,0h0l0,0h0c-.22.3-.4.63-.6.94A5.58,5.58,0,0,1,4.72,7l-.17.26a2.2,2.2,0,0,1-.17.25l-.15.19a.15.15,0,0,0-.16.08L4,8.07a.13.13,0,0,0,0,.12.15.15,0,0,0,.11.11h.11l.09-.09h0l0,0L4.37,8l.14-.21.18-.22.06-.06a.35.35,0,0,1,0-.08l0,0,0,0h0L5,7.17c.25-.4.49-.8.74-1.19l.13-.2h0l0,0A.37.37,0,0,0,6,5.53a.32.32,0,0,0,0-.19.52.52,0,0,0-.18-.15,1.11,1.11,0,0,0-.19-.09L5.4,5,5.2,5l-.15,0-.15,0-.33-.07-.35-.06-.38,0q-.34,0-.69,0c-.2,0-.39,0-.58,0l-.18,0H2.31Zm3.36.88v0Zm-1.27,2h0Z"
            />
            <polygon
                className="cls-3"
                points="5.63 5.59 5.64 5.58 5.63 5.59 5.63 5.59 5.63 5.59"
            />
            <path
                className="cls-3"
                d="M3.82,8.14l0,0a.15.15,0,0,0-.17-.07.16.16,0,0,0-.11.2l0,.07h0s0,0,0,0h0a.75.75,0,0,0,.09.15l.1.14h.09L4,8.56,4,8.48A1.42,1.42,0,0,1,4.1,8.3.17.17,0,0,0,4,8.08L4,8.06a.16.16,0,0,0-.14.08Z"
            />
            <path
                className="cls-3"
                d="M3.68,11.4a.14.14,0,0,0-.11,0,.17.17,0,0,0,0,.23h0a1.67,1.67,0,0,1,.08.32,2.54,2.54,0,0,1,0,.29c0,.11,0,.22,0,.33s0,.45,0,.67,0,.47,0,.7v.69a.66.66,0,0,0,0,.14l-.1-.06-.31-.13-.62-.23-.28-.12-.33-.15c-.19-.09-.37-.19-.55-.29l-.63-.37-.6-.39a.16.16,0,0,0-.22.06.2.2,0,0,0,0,.13.14.14,0,0,0,.08.09l.6.39.64.37a8,8,0,0,0,1.21.59l.56.2c.09,0,.19.07.28.12l.26.14.08,0h.1A.23.23,0,0,0,4,15.06a2.11,2.11,0,0,0,0-.25c0-.1,0-.21,0-.32s0-.48,0-.71v-.7c0-.25,0-.5,0-.75a2.57,2.57,0,0,0-.05-.4c0-.07,0-.13,0-.2a.58.58,0,0,0-.15-.29.18.18,0,0,0-.11,0Zm-.11.27h0Zm0,0v0Z"
            />
            <path
                className="cls-3"
                d="M3.72,10.93l-.08,0-.1.05-.29.14c-.19.09-.39.15-.58.24s-.44.2-.65.31c-.4.2-.78.42-1.15.65l-.32.21a2.51,2.51,0,0,0-.32.25.14.14,0,0,0,0,.11.16.16,0,0,0,0,.11.12.12,0,0,0,.11,0A.14.14,0,0,0,.46,13h0a1.88,1.88,0,0,1,.24-.18L1,12.64l.51-.31c.37-.21.74-.41,1.13-.59h0l.27-.12.29-.11.31-.14.13-.07v0c0,.08.08.15.16.15a.16.16,0,0,0,.11,0,.22.22,0,0,0,0-.11,1,1,0,0,0,0-.24c0-.07-.05-.14-.11-.16a.15.15,0,0,0-.09,0Z"
            />
            <path
                className="cls-3"
                d="M5.37,16.57l-.06,0a.16.16,0,0,0-.06.18.36.36,0,0,0,0,.09.23.23,0,0,0,.07.07l.16.13.26.17.31.2.57.38c.38.26.77.52,1.17.76l.19.11a1.38,1.38,0,0,0,.27.14.15.15,0,0,0,.17-.08.12.12,0,0,0,0-.08.14.14,0,0,0-.05-.11.68.68,0,0,0-.12-.12.17.17,0,0,0-.15,0l-.1,0-.28-.17-.57-.37L6,17l-.31-.2,0,0a.19.19,0,0,0,0-.13.18.18,0,0,0-.1-.07H5.37Z"
            />
            <path
                className="cls-3"
                d="M5.16,17.06a1.91,1.91,0,0,0-.06.33,2,2,0,0,0,0,.25V18c0,.19,0,.39,0,.59,0,.38,0,.75,0,1.13l-.09.63a.77.77,0,0,1,0,.15,1.66,1.66,0,0,0,0,.22.15.15,0,0,0,0,.11s0,.05.07.06a.21.21,0,0,0,.19,0l.09,0,.07,0,.1-.05.63-.34c.19-.1.38-.2.56-.31L7,19.84l.39-.32c.24-.21.48-.42.73-.62h0l.22-.19a.43.43,0,0,0,.11-.12.17.17,0,0,0,0-.2.18.18,0,0,0-.16,0,.16.16,0,0,0-.15.15l0,0-.1.08H8l-1,.83c-.13.1-.26.21-.4.3l-.24.15L6.12,20l-.47.25-.41.22s0-.07,0-.1,0-.22,0-.33a5.2,5.2,0,0,0,.06-.68c0-.23,0-.46,0-.69s0-.45,0-.67,0-.41,0-.61a2.33,2.33,0,0,1,0-.28.15.15,0,0,0-.11-.19h0a.18.18,0,0,0-.16.13ZM8,18.62v0Z"
            />
            <path
                className="cls-3"
                d="M9.16,5.12A6.51,6.51,0,0,0,7.39,6,6.81,6.81,0,0,0,5.57,7.76a0,0,0,0,1,0,0h0a1.37,1.37,0,0,0-.13.2c0,.09-.1.18-.16.27a.41.41,0,0,1,0,.09h0l0,0a.78.78,0,0,0,0,.14c-.08.21-.16.43-.25.65l-.24.64,0,.07a6.6,6.6,0,0,0,0,3.3c0,.12.07.24.11.36a6.6,6.6,0,0,0,.86,1.72,6.71,6.71,0,0,0,3,2.37,6.61,6.61,0,0,0,1,.29,6.31,6.31,0,0,0,1,.15A6.66,6.66,0,0,0,15.89,16l.21-.23v0l0,0,0,0,0,0s0,0,0-.05a.86.86,0,0,1,.07-.1,5.23,5.23,0,0,0,.4-.56l.08-.15s0,0,0-.08l0,0,0,0h0l.06-.12a6.38,6.38,0,0,0,.66-1.8,6.73,6.73,0,0,0-.33-3.74,6.81,6.81,0,0,0-.93-1.64,7.85,7.85,0,0,0-.67-.74A7.68,7.68,0,0,0,14.87,6a6.18,6.18,0,0,0-1.76-.88,6.54,6.54,0,0,0-2-.32h-.09a6.83,6.83,0,0,0-1.9.28Zm2.56.07h0a6.42,6.42,0,0,1,1.61.39,6.71,6.71,0,0,1,1.42.77h0A6.7,6.7,0,0,1,16,7.48a6.24,6.24,0,0,1,.87,1.39l0,0a6.63,6.63,0,0,1,.5,1.64v-.05a6.61,6.61,0,0,1,.05,1.72v0a6.35,6.35,0,0,1-1.17,3.07,6.53,6.53,0,0,1-1.11,1.18h0a6.31,6.31,0,0,1-1.37.86,6.21,6.21,0,0,1-1.62.5h0a6.31,6.31,0,0,1-1.68.05,6.67,6.67,0,0,1-1.6-.38,6.42,6.42,0,0,1-2.63-1.91,6.78,6.78,0,0,1-.86-1.38l-.09-.22h0l0,0v0h0a5.88,5.88,0,0,1-.27-.84h0v-.08c0-.11,0-.23-.07-.35h0c0-.13,0-.27,0-.41a6.53,6.53,0,0,1,0-1.25,6.44,6.44,0,0,1,.39-1.64A6.82,6.82,0,0,1,6,7.76,6.59,6.59,0,0,1,7.08,6.58h0a6.57,6.57,0,0,1,1.33-.83,6.16,6.16,0,0,1,1.63-.5h0a6.45,6.45,0,0,1,1.7,0Zm4.48,10h0Zm-1.13,1.2h0Z"
            />
            <polygon
                className="cls-3"
                points="4.84 12.49 4.84 12.49 4.84 12.49 4.84 12.49 4.84 12.49"
            />
            <polygon
                className="cls-3"
                points="4.84 12.49 4.84 12.49 4.84 12.49 4.84 12.49 4.84 12.49"
            />
            <polygon
                className="cls-3"
                points="11.72 5.19 11.72 5.19 11.72 5.19 11.72 5.19 11.72 5.19 11.72 5.19 11.72 5.19"
            />
            <polygon
                className="cls-3"
                points="4.84 12.48 4.84 12.49 4.84 12.48 4.84 12.48 4.84 12.48 4.84 12.48"
            />
            <polygon
                className="cls-3"
                points="7.09 6.57 7.09 6.57 7.09 6.57 7.09 6.57 7.09 6.57"
            />
            <polygon
                className="cls-3"
                points="4.84 12.49 4.84 12.49 4.84 12.49 4.84 12.49 4.84 12.49 4.84 12.49"
            />
            <polygon
                className="cls-3"
                points="4.84 12.5 4.84 12.51 4.84 12.5 4.84 12.5 4.84 12.5 4.84 12.5"
            />
            <polygon
                className="cls-3"
                points="12.09 17.7 12.09 17.7 12.1 17.7 12.09 17.7 12.09 17.7 12.09 17.7"
            />
        </svg>
    )
}

const Photon = styled(UnstyledPhoton)`
    .cls-1 {
        fill: #01a2a6;
        opacity: 0.37;
    }

    .cls-2 {
        fill: ${(props) => props.color};
    }

    .cls-3 {
        fill: #161616;
    }
`

const UnstyledRays = ({ className }) => {
    return (
        <svg
            className={className}
            style={{ top: 0, left: 0, position: "absolute" }}
            id="Draw_Layer"
            data-name="Draw Layer"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 750.71 389.87"
        >
            <path
                className="cls-1"
                d="M349.75,237.7l.12.37c.07.24.15.48.2.72a1.87,1.87,0,0,0-.4-1.3l.08.21Z"
            />
            {/* <path className="cls-2" d="M383.91,166.49a0,0,0,0,0,0,0l-.12.29-.31.71-.47,1.34-.43,1.25q28.35,13.22,56.69,26.36l13.54,6.29,43,20,49.69,23.08,2.26,1.06.11,0,.15.06.21.09a1.82,1.82,0,0,0,.52.08,2,2,0,0,0,.53-.08,2,2,0,0,0,1.17-.9,1.91,1.91,0,0,0,.19-1.51,1.88,1.88,0,0,0-.9-1.18l-27.06-12.56-26.05-12.1-13.61-6.33-42.9-19.93-28.07-13-27.57-12.8-.16-.07-.3-.13-.13,0Z"/> */}
            <path
                className="cls-2"
                d="M379.87,176.63h0c-.53,1.23-1,2.45-1.55,3.63q21.44,13.43,42.85,26.79l.1.06,32.1,20L466,235l12.16,7.59,16.82,10.5a1.77,1.77,0,0,0,1,.28,2,2,0,0,0,1.73-1,2,2,0,0,0-.71-2.69l-42.37-26.45-.54-.33-22.47-14-22.76-14.21-7.94-5-21-13.08Z"
            />
            {/* <path className="cls-2" d="M375.76,185.78h0c-.67,1.25-1.34,2.41-2,3.43l19.06,16.48,19.05,16.44,17.33,15,17.33,15,.61.52a2,2,0,0,0,1.38.58,2,2,0,0,0,1.39-.58,2,2,0,0,0,.58-1.39,1.89,1.89,0,0,0-.58-1.39l-33.75-29.13-39-33.68-.92-.8-.46-.4Z"/> */}
            <path
                className="cls-2"
                d="M369.1,196.29h0l-.56.79-.17.24c-.52.75-1.06,1.49-1.59,2.2l31.5,33.93.19.21L414,250.38l1.12,1.2a1.92,1.92,0,0,0,1.35.54,2.05,2.05,0,0,0,1.43-.62,2,2,0,0,0,.53-1.41,2.06,2.06,0,0,0-.61-1.37L390.38,219.2l-1.95-2.1-9.66-10.4-9.66-10.4Z"
            />
            {/* <path className="cls-2" d="M360.54,206.86h0l-.23.24c-.65.71-1.39,1.51-2.15,2.31l-.19.22-.08.11-.09.1,12.36,19.94,12.35,19.91.16.26,9.63,15.52.29.46a2,2,0,0,0,1.72,1,2,2,0,0,0,1-.27,2,2,0,0,0,.91-1.24A1.87,1.87,0,0,0,396,264l-.1-.15-.1-.16-25.16-40.56-5-8.13-5-8.07,0,0Z"/> */}
            <path
                className="cls-2"
                d="M350.58,218.39h0l-.27.3L350,219l-.66.75-1.22,1.39-.25.31-.25.3,15.52,45.69.06.16q2.79,8.22,5.59,16.45l.07.21a2,2,0,0,0,.91,1.2,1.91,1.91,0,0,0,1,.27,1.86,1.86,0,0,0,.52-.07,2.1,2.1,0,0,0,1.23-1,1.73,1.73,0,0,0,.14-1.4l-14.92-43.9-3.56-10.48-3.56-10.49,0,0Z"
            />
        </svg>
    )
}

const useStyles = makeStyles()((theme) => ({
    rail: {
        backgroundImage:
            "linear-gradient(90deg, rgba(97,0,0,1) 0%, rgba(219,0,0,1) 15%, rgba(255,0,0,1) 30%, rgba(255,190,0,1) 45%, rgba(129,255,0,1) 60%, rgba(0,213,255,1) 75%, rgba(106,0,255,1) 90%, rgba(97,0,97,1) 100%)",
        height: 20,
        borderRadius: 4,
        opacity: 1,
    },
    track: {
        background: "none",
        height: 20,
        borderRadius: 4,
    },
    root: {
        height: 20,
    },
    thumb: {
        height: 40,
        width: 40,
    },
}))

const CustomSlider = (props) => {
    const { classes } = useStyles()
    return <Slider classes={classes} {...props} />
}

const Rays = styled(UnstyledRays)`
    .cls-1 {
        fill: ${(props) => props.color};
        opacity: 0.52;
    }

    .cls-2 {
        fill: ${(props) => props.color};
    }
`

class PhotonBanner extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            blink: false,
            lit: false,
            color: "rgb(255, 0, 0)",
            threshold: 520,
        }

        this.timeouts = []
    }

    componentDidMount() {
        let tweenTime = 0.5

        let tl1 = new TimelineMax({ repeat: -1 })
        tl1.to(".photon1", tweenTime, {
            ease: Power0.easeNone,
            x: "25%",
            y: "25%",
            opacity: 1,
            delay: Math.random(),
        }).to(".photon1", tweenTime, {
            ease: Power0.easeNone,
            x: "50%",
            y: "50%",
            opacity: 0,
        })

        let tl4 = new TimelineMax({ repeat: -1 })
        tl4.to(".photon4", tweenTime, {
            ease: Power0.easeNone,
            x: "50%",
            y: "15%",
            opacity: 1,
            delay: Math.random(),
        }).to(".photon4", tweenTime, {
            ease: Power0.easeNone,
            x: "100%",
            y: "30%",
            opacity: 0,
        })

        let tl2 = new TimelineMax({ repeat: -1 })
        tl2.to(".photon2", tweenTime, {
            ease: Power0.easeNone,
            x: "150%",
            y: "25%",
            opacity: 1,
            delay: Math.random(),
        }).to(".photon2", tweenTime, {
            ease: Power0.easeNone,
            x: "300%",
            y: "50%",
            opacity: 0,
        })

        let tl5 = new TimelineMax({ repeat: -1 })
        tl5.to(".photon5", tweenTime, {
            ease: Power0.easeNone,
            x: "200%",
            y: "25%",
            opacity: 1,
            delay: Math.random(),
        }).to(".photon5", tweenTime, {
            ease: Power0.easeNone,
            x: "400%",
            y: "50%",
            opacity: 0,
        })

        let tl3 = new TimelineMax({ repeat: -1 })
        tl3.to(".photon3", tweenTime, {
            ease: Power0.easeNone,
            x: "250%",
            y: "25%",
            opacity: 1,
            delay: Math.random(),
        }).to(".photon3", tweenTime, {
            ease: Power0.easeNone,
            x: "500%",
            y: "50%",
            opacity: 0,
        })

        let tl6 = new TimelineMax({ repeat: -1 })
        tl6.to(".photon6", tweenTime, {
            ease: Power0.easeNone,
            x: "250%",
            y: "25%",
            opacity: 1,
            delay: Math.random(),
        }).to(".photon6", tweenTime, {
            ease: Power0.easeNone,
            x: "500%",
            y: "50%",
            opacity: 0,
        })

        let tl7 = new TimelineMax({ repeat: -1 })
        tl7.to(".photon7", tweenTime, {
            ease: Power0.easeNone,
            x: "500%",
            y: "25%",
            opacity: 1,
            delay: Math.random(),
        }).to(".photon7", tweenTime, {
            ease: Power0.easeNone,
            x: "1000%",
            y: "50%",
            opacity: 1,
        })

        this.blink()
    }

    blink() {
        let interval = 1 + Math.random() * 6
        this.timeouts.push(
            setTimeout(() => {
                this.setState({
                    blink: true,
                })
                setTimeout(() => {
                    this.setState({
                        blink: false,
                    })
                }, 150)
                this.blink()
            }, interval * 1000)
        )
    }

    handleSliderChange = (event, value) => {
        let wavelength = -400 * value + 780
        const [r, g, b] = nmToRGB(wavelength)
        let colorString = "rgb(" + r + ", " + g + ", " + b + ")"
        this.setState({
            color: colorString,
        })

        if (wavelength < this.state.threshold && !this.state.lit) {
            this.setState({
                lit: true,
            })
        } else if (wavelength > this.state.threshold && this.state.lit) {
            this.setState({
                lit: false,
            })
        }
    }

    componentWillUnmount() {
        for (var i = 0; i < this.timeouts.length; i++) {
            clearTimeout(this.timeouts[i])
        }
        this.timeouts = []
    }

    render() {
        // This is a WIP attempt to make the thumb control on the slider match the color in state
        // let props = {color: this.state.color}
        // let classes = makeStyles(props)
        // console.log(classes)
        return (
            <SceneWrapper>
                <div style={{ position: "relative" }}>
                    <img
                        src={this.state.blink ? einsteinBlink : einstein}
                        id="einstein"
                        style={{ top: 0, left: 0, position: "absolute" }}
                    />
                    <img src={scene} style={{ position: "relative" }} />
                    <img
                        src={this.state.lit ? bulbLit : bulb}
                        id="einstein"
                        style={{ top: 0, left: 0, position: "absolute" }}
                    />
                    <Rays color={this.state.color} />
                    <Photon
                        color={this.state.color}
                        number={1}
                        top="54%"
                        left="46%"
                    ></Photon>
                    <Photon
                        color={this.state.color}
                        number={2}
                        top="50%"
                        left="49%"
                    ></Photon>
                    <Photon
                        color={this.state.color}
                        number={3}
                        top="43%"
                        left="50%"
                    ></Photon>
                    <Photon
                        color={this.state.color}
                        number={4}
                        top="54%"
                        left="46%"
                    ></Photon>
                    <Photon
                        color={this.state.color}
                        number={5}
                        top="50%"
                        left="49%"
                    ></Photon>
                    <Photon
                        color={this.state.color}
                        number={6}
                        top="43%"
                        left="50%"
                    ></Photon>
                    <Photon
                        color={this.state.color}
                        number={7}
                        top="54%"
                        left="46%"
                    ></Photon>
                </div>
                <CustomSlider
                    min={0}
                    max={1}
                    defaultValue={0.3}
                    step={0.01}
                    onChange={this.handleSliderChange}
                />
                <Caption
                    banner
                    text="In 1905, Einstein had an idea: maybe light travels in discrete bunches of energy. This helped explain the photoelectric effect, in which a higher frequency (related to the color of light), but not a higher brightness (the amount of light), liberated electrons from a metal. Play around with the slider above to find the color that frees electrons and turns on the lightbulb."
                />
            </SceneWrapper>
        )
    }
}

Photon.propTypes = {
    number: PropTypes.number,
    top: PropTypes.string,
    left: PropTypes.string,
    color: PropTypes.string,
}

UnstyledRays.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
}

// Taken from https://academo.org/demos/wavelength-to-colour-relationship/
let nmToRGB = (wavelength) => {
    var Gamma = 0.8,
        IntensityMax = 255,
        factor,
        red,
        green,
        blue
    if (wavelength >= 380 && wavelength < 440) {
        red = -(wavelength - 440) / (440 - 380)
        green = 0.0
        blue = 1.0
    } else if (wavelength >= 440 && wavelength < 490) {
        red = 0.0
        green = (wavelength - 440) / (490 - 440)
        blue = 1.0
    } else if (wavelength >= 490 && wavelength < 510) {
        red = 0.0
        green = 1.0
        blue = -(wavelength - 510) / (510 - 490)
    } else if (wavelength >= 510 && wavelength < 580) {
        red = (wavelength - 510) / (580 - 510)
        green = 1.0
        blue = 0.0
    } else if (wavelength >= 580 && wavelength < 645) {
        red = 1.0
        green = -(wavelength - 645) / (645 - 580)
        blue = 0.0
    } else if (wavelength >= 645 && wavelength < 781) {
        red = 1.0
        green = 0.0
        blue = 0.0
    } else {
        red = 0.0
        green = 0.0
        blue = 0.0
    }

    // Let the intensity fall off near the vision limits
    if (wavelength >= 380 && wavelength < 420) {
        factor = 0.3 + (0.7 * (wavelength - 380)) / (420 - 380)
    } else if (wavelength >= 420 && wavelength < 701) {
        factor = 1.0
    } else if (wavelength >= 701 && wavelength < 781) {
        factor = 0.3 + (0.7 * (780 - wavelength)) / (780 - 700)
    } else {
        factor = 0.0
    }
    if (red !== 0) {
        red = Math.round(IntensityMax * Math.pow(red * factor, Gamma))
    }
    if (green !== 0) {
        green = Math.round(IntensityMax * Math.pow(green * factor, Gamma))
    }
    if (blue !== 0) {
        blue = Math.round(IntensityMax * Math.pow(blue * factor, Gamma))
    }

    return [red, green, blue]
}

export default PhotonBanner
export { meta }
